import DefaultSiteCreator from './default';

const creators = {
  default: DefaultSiteCreator,
};

export default function getSiteTypeProperties(properties) {
  const { type } = properties;

  return creators[type] ? creators[type](properties) : creators.default(properties);
}
